export function MyStudyGroupsRoutes($stateProvider: ng.ui.IStateProvider) {
  $stateProvider
    .state('my.studyGroups', {
      url: 'study-groups',
      templateUrl: 'capability-ng-study-groups/src/views/study_groups/study_groups.html',
      controller: 'StudyGroupsController',
      controllerAs: '$ctrl',
      data: {
        viewTitle: 'Study Buddies',
        hasMainMenu: true,
        ignoredInHistory: false
      }
    })
    .state('my.studyGroupMembers', {
      url: 'study-group-members/:sectionId',
      templateUrl: 'capability-ng-study-groups/src/views/study_group_members/study_group_members.html',
      controller: 'StudyGroupMembersController',
      controllerAs: '$ctrl',
      data: {
        viewTitle: 'Study Group Members',
        hasMainMenu: false,
        ignoredInHistory: false
      }
    });
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-study-groups/src/study_groups_routes.ts